import React from 'react';
import { Drawer, Input, Card, Typography, Row, Col, Image } from 'antd';
import TargetDetails from './TargetDetails';
import { useState } from 'react';
import { cordConvertEng } from '../../utils'
import {prUrl} from '../config.js'
import search from '../../images/Union.svg'
import Icon from "@ant-design/icons";
import locationIcon from '../../images/location.png'

const GotoButton = (props) => {    
    return (
        <Icon component={location} onClick={(e) => props.gotoMarker(props.marker, e)}/>
    );
}

const location = () => (
    <Image src={locationIcon} preview={false}/>
)

const { Title } = Typography

const TargetListDrawer = (props) => {
    const [isTargetModalOpen, setIsTargetModalOpen] = useState(false)
    const [target, setTarget] = useState(null)
    const [active, setActive] = useState('')

    const handleTargetModalShow = () => {
        setIsTargetModalOpen(!isTargetModalOpen)
        setActive('')
    }
    const handleOnClick = (target, index) => {
        handleTargetModalShow()
        setTarget(target)
        setActive(index)
    }

    const gotoMarker = (marker) => {
        props.globe.goTo(marker.position.latitude, marker.position.longitude, 10e4)
    }

    const searchIcon = () => (
        <Image src={search} preview={false}/>
    )

    return(
        <React.Fragment>
            <Drawer
                className='listDrawer'
                title={<span className="drawerTitle">目标列表</span>}
                placement="left"
                closable={false}
                onClose={props.handleTargetDrawerShow}
                visible={props.isTargetDrawerShow}
                getContainer={false}
                width={'450'}>
                <div className="drawerSearch">
                    <Input placeholder="请输入筛选条件……" type="text" onKeyUp={props.handleFilter}/>
                    <div className="drawerSearchIcon">
                        <Icon component={searchIcon}/>
                    </div>
                </div>
                {
                    props.filteredTargets.map((item, index) => 
                        (
                            <Card
                                className={active === index ? 'drawer-list-item-active drawer-list-item' : 'drawer-list-item'}
                                hoverable
                                title={<Title level={5} style={{cursor:'pointer'}} onClick={(e) => handleOnClick(item.target, index, e)}>{item.target.chnName}</Title>} 
                                extra={<GotoButton gotoMarker={gotoMarker} marker={item.marker} globe={props.globe}/>} 
                                style={{ width: 385, border:'false' }}>
                                <Row  align='middle' justify='center'>
                                    <Col span={10}>
                                        {
                                            item.target.image ? 
                                            <Image src={prUrl+item.target.image} preview={false} style={{cursor:'pointer'}} onClick={(e) => handleOnClick(item.target, index, e)}/>
                                            : <Image src='./tent2.png'/>
                                        }
                                    </Col>
                                    <Col span={12} offset={1}>                
                                        <p style={{cursor:'pointer'}} onClick={(e) => handleOnClick(item.target, index, e)}>中文名：{item.target.chnName}</p>
                                        <p style={{cursor:'pointer'}} onClick={(e) => gotoMarker(item.marker, e)}>经纬度：{cordConvertEng(item.target.lat, item.target.lon)}</p>
                                        <p style={{cursor:'pointer'}} onClick={(e) => handleOnClick(item.target, index, e)}>驻在国：{item.target.locCountry}</p>
                                        <p style={{cursor:'pointer'}} onClick={(e) => handleOnClick(item.target, index, e)}>所属国：{item.target.opCountry}</p>
                                    </Col>
                                </Row>
                            </Card>
                        )
                    )
                }
            </Drawer>
            {
                isTargetModalOpen ?
                <TargetDetails isModalOpen={isTargetModalOpen} target={target} handleModalShow={handleTargetModalShow}/> : ''
            }
        </React.Fragment>
    )
};

export default TargetListDrawer;